export default __webpack_public_path__ + "static/blog-preview-1-2a6072106470916ad95ebb116601a9c4.jpeg";